import script from "./ImageZoomButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageZoomButton.vue?vue&type=script&setup=true&lang=ts"

import "./ImageZoomButton.vue?vue&type=style&index=0&id=30ff9f79&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ff9f79"]])

export default __exports__